import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.js";
pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

document.addEventListener('turbolinks:load', () => {
    const guidedStationDetailPreview = document.getElementById('guidedStationDetailPreview')
    const guideGuestPreviewScreen = document.getElementById('guideGuestPreviewScreen')
    const sgScreen = document.getElementById('sgScreen')
    const guestPreviewArea = document.getElementById('guestPreviewArea')
    const guidePreviewScrollableTopBarText = document.getElementById('guidePreviewScrollableTopBarText')
    let richTextAreas

    const guidePreviewDetailedWebsite = document.getElementById('guidePreviewDetailedWebsite')
    const guidePreviewDetailedWebsiteHolder = document.getElementById('guidePreviewDetailedWebsiteHolder')

    const pdfContainerGuideDetail = document.getElementById('pdfContainerGuideDetail')
    const pdfScrollArea = document.getElementById('pdfScrollArea')
    const pdfScrollBar = document.getElementById('pdfScrollBar')

    // station guide notes
    const guideStationNotes = document.getElementById('guideStationNotes')
    const guideStationArea = document.getElementById('guideStationArea')
    const guideMultiStationNav = document.getElementById('guideMultiStationNav')
    const guideNotesShowMedia = document.getElementById('guideNotesShowMedia')
    const guideNotesShowNotes = document.getElementById('guideNotesShowNotes')

    let pdfNumPages
    let loadQueueGuideDetail = Promise.resolve(); //queue pdf loads on resize
    let loadingTaskGuideDetail = null; // To track the current PDF loading task
    let latestTaskIdGuideDetail = 0; // save current PDF load task id

    const pdfContainerGuideGuestPreview = document.getElementById('pdfContainerGuideGuestPreview')
    let loadQueueGuideGuestPreview = Promise.resolve(); //queue pdf loads on resize
    let loadingTaskGuideGuestPreview = null; // To track the current PDF loading task
    let latestTaskIdGuideGuestPreview = 0; // save current PDF load task id

    if (guidedStationDetailPreview !== null && sgScreen !== null && guideGuestPreviewScreen !== null &&
        guidePreviewScrollableTopBarText !== null && guestPreviewArea !== null) {

        richTextAreas = sgScreen.getElementsByClassName("trix-content")
        resize()

        if (pdfContainerGuideDetail !== null && pdfScrollBar !== null) {
            showPdfScrollProgress()
        }
    }

    if (guideStationNotes !== null && guideStationArea !== null && guideNotesShowMedia !== null && guideNotesShowNotes !== null) {
        guideNotesShowMedia.addEventListener('click', () => {
            guideNotesShowMedia.classList.add('bg-blue-200')
            guideNotesShowNotes.classList.remove('bg-blue-200')
            guideStationArea.classList.remove('hidden')
            guideStationNotes.classList.add('hidden')
            // Additional behavior for multi stations
            // the multi station navigation has to be enabled again.
            // Therefore, the parent changes the class to adapt the different height from the CSS class
            if (guideMultiStationNav) {
                guideMultiStationNav.classList.remove('hidden')
                guideStationNotes.parentElement.classList.add('guidedScrollAreaMultiStation')
                guideStationNotes.parentElement.classList.remove('guidedScrollArea')
            }
        })
        guideNotesShowNotes.addEventListener('click', () => {
            guideNotesShowMedia.classList.remove('bg-blue-200')
            guideNotesShowNotes.classList.add('bg-blue-200')
            guideStationArea.classList.add('hidden')
            guideStationNotes.classList.remove('hidden')
            // Additional behavior for multi stations
            // the multi station navigation has to be disabled.
            // Therefore, the parent changes the class to adapt the different height from the CSS class
            if (guideMultiStationNav) {
                guideMultiStationNav.classList.add('hidden')
                guideStationNotes.parentElement.classList.add('guidedScrollArea')
                guideStationNotes.parentElement.classList.remove('guidedScrollAreaMultiStation')
            }
        })
    }


    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height
            const guestPreviewHeight = guideGuestPreviewScreen.getBoundingClientRect().height

            // trix
            for (let richTextArea of richTextAreas) {

                //TODO: prüfen ob h1 angepasst werden muss
                if (richTextArea.parentNode.classList.contains('guideGuestPreviewDetailedText')) {
                    // guide guest preview
                    richTextArea.style.fontSize = `${guestPreviewHeight / 20}px`
                    richTextArea.style.lineHeight = `${guestPreviewHeight / 14}px`
                    const h1s = richTextArea.getElementsByTagName('h1')
                    for (let h1 of h1s) {
                        h1.classList.add('font-bold')
                        h1.style.fontSize = `${guestPreviewHeight / 14}px`
                    }
                } else {
                    // guide detail
                    if (richTextArea.parentNode.classList.contains('guideImageDescription')) {
                        //Image media-entry with description
                        richTextArea.style.fontSize = `${currentSgScreenHeight / 50}px`
                        richTextArea.style.lineHeight = `${currentSgScreenHeight / 36}px`
                    } else {
                        //Text media-entry
                        richTextArea.style.fontSize = `${currentSgScreenHeight / 46}px`
                        richTextArea.style.lineHeight = `${currentSgScreenHeight / 30}px`
                    }
                    const h1s = richTextArea.getElementsByTagName('h1')
                    for (let h1 of h1s) {
                        h1.classList.add('font-bold')
                        h1.style.fontSize = `${currentSgScreenHeight / 30}px`
                    }
                }
            }

            handleTourNameScroll()

            if (guidePreviewDetailedWebsite !== null && guidePreviewDetailedWebsiteHolder !== null) {
                resizeIframe()
            }

            // resize guide pdf
            if (pdfContainerGuideDetail !== null) {
                // Cancel the currently running PDF load (if any)
                if (loadingTaskGuideDetail) {
                    loadingTaskGuideDetail.destroy();
                    loadingTaskGuideDetail = null;
                }

                // Generate a new unique ID for the latest resize event
                const currentTaskId = ++latestTaskIdGuideDetail;

                // Add a new PDF load task to the queue, ensuring sequential execution.
                // Any outdated tasks (from previous resizes) will be skipped, and only the latest one will run.
                loadQueueGuideDetail = loadQueueGuideDetail.then(() => {
                    //sequential part -one resize after the other

                    // Ignore outdated tasks
                    if (currentTaskId !== latestTaskIdGuideDetail) {
                        return; // Ignore outdated tasks
                    }
                    // executes the latest load
                    return loadGuideDetailPdf()
                });
            }

            // resize guide-guest-preview pdf
            if (pdfContainerGuideGuestPreview !== null) {
                // Cancel the currently running PDF load (if any)
                if (loadingTaskGuideGuestPreview) {
                    loadingTaskGuideGuestPreview.destroy();
                    loadingTaskGuideGuestPreview = null;
                }

                // Generate a new unique ID for the latest resize event
                const currentTaskId = ++latestTaskIdGuideGuestPreview;

                // Add a new PDF load task to the queue, ensuring sequential execution.
                // Any outdated tasks (from previous resizes) will be skipped, and only the latest one will run.
                loadQueueGuideGuestPreview = loadQueueGuideGuestPreview.then(() => {
                    //sequential part -one resize after the other

                    // Ignore outdated tasks
                    if (currentTaskId !== latestTaskIdGuideGuestPreview) {
                        return; // Ignore outdated tasks
                    }
                    // executes the latest load
                    return loadGuideGuestPreviewPdf()
                });

            }
        })
        resizeObserver.observe(sgScreen);
    }

    function resizeIframe() {
        const guestPreviewHeightScale = guidePreviewDetailedWebsiteHolder.getBoundingClientRect().height/5.684438040345821
        guidePreviewDetailedWebsite.style.transform = `scale(${guestPreviewHeightScale}%)`
        guidePreviewDetailedWebsite.style.transformOrigin = '0 0'
        guidePreviewDetailedWebsite.style.height = `${1/(guestPreviewHeightScale/100) * 100}%`
    }

    /**
     * Loads the PDF from the URL specified in the `data-pdf-url` attribute of `pdfPreviewContainer`.
     *
     * This function:
     * - Retrieves the PDF URL dynamically.
     * - Starts a new PDF loading task using `pdfjsLib.getDocument()`.
     * - Returns a promise that resolves when the PDF is fully loaded.
     * - Ensures only the latest PDF is loaded, as older tasks are ignored in the main execution flow.
     */
    function loadGuideDetailPdf() {

        // Clear previous PDF pages
        pdfContainerGuideDetail.innerHTML = "";

        // Start loading the PDF document asynchronously using pdf.js
        const url = pdfContainerGuideDetail.dataset.pdfUrl
        loadingTaskGuideDetail = pdfjsLib.getDocument(url)

        // Return a promise that resolves when the PDF is fully loaded
        return loadingTaskGuideDetail.promise
            .then(pdf => {

                // set size of scrollbar
                pdfScrollBar.style.height = `${100/pdf.numPages}%`
                pdfNumPages = pdf.numPages
                if (pdfNumPages > 1) {
                    pdfScrollArea.classList.remove('hidden')
                }

                // loop over pages of pdf
                for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                    pdf.getPage(pageNum).then(page => {

                        // get pdf page dimensions
                        const originalViewport = page.getViewport({ scale: 1 });
                        const originalWidth = originalViewport.width;
                        const originalHeight = originalViewport.height;

                        // Get pdfContainerGuideDetail dimensions (already fixed)
                        const pdfContainerGuideDetail = document.getElementById('pdfContainerGuideDetail')

                        // handle running promise after navigating away
                        if (pdfContainerGuideDetail == null) {
                            return
                        }

                        const containerWidth  = pdfContainerGuideDetail.getBoundingClientRect().width;
                        const containerHeight  = pdfContainerGuideDetail.getBoundingClientRect().height;

                        // Calculate scale to fit while maintaining aspect ratio
                        const scaleX = containerWidth / originalWidth;
                        const scaleY = containerHeight / originalHeight;
                        const scale =  Math.min(scaleX, scaleY) ; // Use the smaller scale to avoid distortion

                        // Create a newCanvas inside pdfContainerGuideDetail
                        const newCanvas = document.createElement("canvas");
                        newCanvas.classList.add("pdfCanvasPage")
                        const context = newCanvas.getContext("2d");

                        // Compute the new viewport with correct scaling
                        const scaledViewport = page.getViewport({ scale });

                        // Set the newCanvas dimensions based on scaled PDF size
                        newCanvas.width = scaledViewport.width;
                        newCanvas.height = scaledViewport.height;

                        // set padding to center pages
                        const marginToCenter = (containerHeight - scaledViewport.height)/2
                        newCanvas.classList.add('py-4.4p')

                        // Append newCanvas to the div container
                        pdfContainerGuideDetail.appendChild(newCanvas);

                        // Render PDF on newCanvas
                        const renderContext = {
                            canvasContext: context,
                            viewport: scaledViewport
                        };

                        page.render(renderContext)
                    })
                }
            })
            .catch(() => {
                // handle destroy of task without  exception
            })
            .finally(() => {
                loadingTaskGuideDetail = null;
            })
    }

    function loadGuideGuestPreviewPdf() {
        // Start loading the PDF document asynchronously using pdf.js
        const url = pdfContainerGuideGuestPreview.dataset.pdfUrl
        loadingTaskGuideGuestPreview = pdfjsLib.getDocument(url)

        // Return a promise that resolves when the PDF is fully loaded
        return loadingTaskGuideGuestPreview.promise
            .then(pdf => {
                pdf.getPage(1).then(page => {

                    // get pdf dimensions
                    const originalViewport = page.getViewport({ scale: 1 });
                    const originalWidth = originalViewport.width;
                    const originalHeight = originalViewport.height;

                    // Get pdfPreviewContainer dimensions (already fixed)
                    const pdfPreviewContainer = document.getElementById('pdfContainerGuideGuestPreview')

                    // handle running promise after navigating away
                    if (pdfPreviewContainer == null) {
                        return
                    }

                    const containerWidth  = pdfPreviewContainer.getBoundingClientRect().width;
                    const containerHeight  = pdfPreviewContainer.getBoundingClientRect().height;

                    // Calculate scale to fit while maintaining aspect ratio
                    const scaleX = containerWidth / originalWidth;
                    const scaleY = containerHeight / originalHeight;
                    const scale =  Math.min(scaleX, scaleY) ; // Use the smaller scale to avoid distortion

                    // Create a newCanvas inside pdfPreviewContainer
                    const newCanvas = document.createElement("canvas");
                    newCanvas.id = "pdfCanvas"
                    const context = newCanvas.getContext("2d");

                    // Compute the new viewport with correct scaling
                    const scaledViewport = page.getViewport({ scale });

                    // Set the newCanvas dimensions based on scaled PDF size
                    newCanvas.width = scaledViewport.width;
                    newCanvas.height = scaledViewport.height;

                    // Append newCanvas to the div container
                    const oldCanvas = document.getElementById('pdfCanvas')
                    if (oldCanvas !== null) {
                        pdfPreviewContainer.replaceChild(newCanvas, oldCanvas)
                    } else {
                        pdfPreviewContainer.appendChild(newCanvas);
                    }


                    // Render PDF on newCanvas
                    const renderContext = {
                        canvasContext: context,
                        viewport: scaledViewport
                    };

                    page.render(renderContext)
                })
            })
            .catch(() => {

            })
            .finally(() => {
                loadingTaskGuideGuestPreview = null;
            });
    }

    /**
     * Attaches a scroll listener to the PDF container to update the vertical position of the custom scrollbar.
     *
     * The scrollbar indicator (pdfScrollBar) reflects the user's current scroll progress through the PDF.
     * If the total number of pages (pdfNumPages) is known, the indicator's position is adjusted so that
     * it stays aligned proportionally, accounting for the height each page would occupy.
     */
    function showPdfScrollProgress() {
        pdfContainerGuideDetail.addEventListener('scroll', () => {
            const scrollTop = pdfContainerGuideDetail.scrollTop;
            const scrollHeight = pdfContainerGuideDetail.scrollHeight;
            const clientHeight = pdfContainerGuideDetail.clientHeight;

            const scrollProgress = (scrollTop / (scrollHeight - clientHeight)) * 100;
            if (pdfNumPages !== null) { // set inside loadGuideDetailPdf
                pdfScrollBar.style.top = `${scrollProgress-(scrollProgress* (1.0/pdfNumPages))}%`;
            }


        });
    }

    // handle scroll of tour name
    function handleTourNameScroll() {
        const offsetHeight = guidePreviewScrollableTopBarText.offsetHeight
        const lineHeight = parseInt(getComputedStyle(guidePreviewScrollableTopBarText).lineHeight)
        const lines = Math.round(offsetHeight/lineHeight)

        // only scroll if there are more than 3 lines
        if (lines > 3) {
            guidePreviewScrollableTopBarText.classList.add('guidePreviewScrollableTopBarTextScroll')
            // set scroll transform-translate-X and animation speed depending on text length
            const scrollOffset = (lines-3)/(lines) *100
            const animationTime = lines-3
            guidePreviewScrollableTopBarText.style.animationDuration = `${animationTime}s`
            guidePreviewScrollableTopBarText.style.setProperty('--scrollTransformPercentage', `-${scrollOffset}%`);
        }
    }
})